module.exports = __webpack_public_path__ + "img/signinSuccessbg.be29e16f.webp";